import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class Paging extends Vue {
  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("config", patientNamespace)
  config!: any;

  selected = "";

  select(target: string) {
    if (target === this.selected) {
      this.selected = "";
    } else {
      this.selected = target;
    }
  }

  get iterablePaging() {
    if (!this.vars) {
      return [];
    }
    const rules = this.vars.alertRules
      .map((alert: any) => {
        let data: any;
        try {
          data = JSON.parse(alert.paging);
          if (alert.logic) {
            const logic = JSON.parse(alert.logic);
            Object.assign(data, logic);
          }
        } catch (e) {
          data = {};
        }
        if (!data) {
          data = {};
        }
        data.description = alert.description;
        if (data.who != null && data.who != "") {
          data.who = data.who
            .replace(new RegExp(",#", "g"), "<br>")
            .replace(new RegExp(",", "g"), " ")
            .replace(new RegExp("#", "g"), "");
        }
        return data;
      })
      .filter((alert: any) => {
        return Object.keys(alert).length > 1 && (alert.who || alert.pageWho);
      });
    return rules;
  }
}
